import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class ChangeFiltersService {
  constructor() { }

  private stateReadyMenuArr = [];
  private stateForScrollMidColumnUp = new BehaviorSubject<boolean>(null);
  private stateForSearchBoxSubject = new BehaviorSubject<number>(4);
  private stateForSelectionMenuBoxSubject = new BehaviorSubject<number>(4);
  private showUsedRecipes = new BehaviorSubject<boolean>(false);
  private stateReadyMenu = new BehaviorSubject<number[]>([]);
  private allowResetRecipes = new BehaviorSubject<boolean>(true);
  private showModalReadyMenu = new BehaviorSubject<boolean>(false);
  private listReadyMenu = new BehaviorSubject<any[]>([]);

  getListReadyMenu(): BehaviorSubject<any[]> {
    return this.listReadyMenu;
  }

  setListReadyMenu(list: any[]) {
    list.forEach(item => {
      item.active = false;
    });
    this.listReadyMenu.next(list);
  }

  changeShowModalReadyMenu(status: boolean) {
    this.showModalReadyMenu.next(status);
  }

  getShowModalReadyMenu(): BehaviorSubject<boolean> {
    return this.showModalReadyMenu;
  }

  getAllowResetRecipes(): BehaviorSubject<boolean> {
    return this.allowResetRecipes;
  }

  setAllowResetRecipes(status: boolean) {
    this.allowResetRecipes.next(status);
  }

  getStateReadyMenu(): BehaviorSubject<number[]> {
    return this.stateReadyMenu;
  }

  getPromiseStateReadyMenu() {
    return new Promise((resolve) => {
      resolve(this.stateReadyMenu.value);
    });
  }

  getStateForSearch(): BehaviorSubject<number> {
    return this.stateForSearchBoxSubject;
  }

  setStateForSearch(value: number) {
    this.stateForSearchBoxSubject.next(value);
  }

  getStateSelectionMenu(): BehaviorSubject<number> {
    return this.stateForSelectionMenuBoxSubject;
  }

  setStateForSelectionMenu(value: number) {
    this.stateForSelectionMenuBoxSubject.next(value);
  }

  callNewScroll() {
    this.stateForScrollMidColumnUp.next(true);
  }

  getPageScroll(): Observable<boolean> {
    return this.stateForScrollMidColumnUp.asObservable();
  }

  changeUsedState(state: boolean) {
    this.showUsedRecipes.next(state);
  }

  showReadyRecipes(state: number | string[]) {
    this.showUsedRecipes.next(false);
    if (typeof state === 'number') {
      const indexOfState = this.stateReadyMenuArr.indexOf(state);
      this.stateReadyMenuArr = indexOfState < 0 ? [state] : [];
    } else {
      this.stateReadyMenuArr = state.map(x => +x);
    }
    this.stateReadyMenu.next(this.stateReadyMenuArr);
  }

  cancelStateReadyMenu() {
    this.stateReadyMenu.next([]);
  }

  /**Возвращает observable объект, содержащий информацию о выбранном типе рецептов (найденные или использованные) */
  getUsedRecipesState() {
    return this.showUsedRecipes.asObservable();
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/services/change-filters.service.ts